var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "header",
      class: {
        "header--sortable": !!_vm.canSort,
        "header--sorted": _vm.column.id === _vm.sortBy,
      },
    },
    [
      _c("div", { staticClass: "name", on: { click: _vm.setSortBy } }, [
        _c("div", { staticClass: "name__view name__view--lg" }, [
          _vm._v(" " + _vm._s(_vm.column.name) + " "),
        ]),
        _c("div", { staticClass: "name__view name__view--sm" }, [
          _vm._v(" " + _vm._s(_vm.column.shortName) + " "),
        ]),
      ]),
      _vm.filter
        ? _c(
            "div",
            { staticClass: "filter" },
            [
              _c("Button", {
                directives: [
                  {
                    name: "b-popover",
                    rawName: "v-b-popover.hover.blur.top",
                    value: _vm.hasFilterValue
                      ? "Изменить фильтр"
                      : "Применить фильтр",
                    expression:
                      "hasFilterValue ? 'Изменить фильтр' : 'Применить фильтр'",
                    modifiers: { hover: true, blur: true, top: true },
                  },
                ],
                attrs: {
                  size: "small",
                  icon: {
                    icon: "filter-column",
                    activeColor: "blue",
                  },
                  active: _vm.hasFilterValue,
                  "no-border": "",
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("filter", {
                      column: _vm.column,
                      filter: _vm.filter,
                    })
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }